import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRichText = loadable(() => import(/* webpackChunkName: "content/guestSiteRichText" */ '.'), 'RichText');
